import { useMutation, useQueryClient } from "react-query";

import { crearPlan, updatePlan, deletePlan} from '../../services/Planes';

import { toast } from 'react-hot-toast';
const queryKey = "planes";

export const usePlanesMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addPlan = useMutation((body) => crearPlan(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
 
  const updatePlanC = useMutation(
    (body) => updatePlan( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removePlan = useMutation((id) => deletePlan( id), {
    onSuccess,
    onError,
  });

  return { addPlan, updatePlanC, removePlan };
};
export default usePlanesMutations;